export const HARVEST_PRINT_PROPERTIES_SET = 'HARVEST_PRINT_PROPERTIES_SET';
